<script setup>
import HeadingSection from '@/components/_common/Heading/HeadingSection.vue';
import AlertsNotificationsForm from '@/components/alerts/_common/AlertsNotificationsForm.vue';
import { setTitle } from '@/utils/title';

setTitle('Notification Settings');
</script>

<template>
  <section class="max-w-[860px]">
    <HeadingSection
      class="mb-[35px]"
      desc="How you personally hear about activity on this account. Everyone else on the account sets their own."
      heading="Notifications"
    />
    <AlertsNotificationsForm />
  </section>
</template>
